import type { EnemyDefinition, EnemyInstance } from "../domain/types";

export const isTargetable = (enemy: EnemyInstance): boolean => enemy.state === "active";
export const isDamageable = (enemy: EnemyInstance): boolean => enemy.state === "active";
export const isMoving = (enemy: EnemyInstance): boolean => enemy.state === "active";

export function beginSpawning(enemy: EnemyInstance, definition: EnemyDefinition): void {
  if (enemy.state !== "pending") return;
  enemy.state = "spawning";
  enemy.lifecycleElapsedMs = 0;
  enemy.lifecycleRemainingMs = Math.max(definition.spawnDurationMs, definition.spawnProtectionMs);
}

export function beginDying(enemy: EnemyInstance, definition: EnemyDefinition): boolean {
  if (!isDamageable(enemy)) return false;
  enemy.state = "dying";
  enemy.lifecycleElapsedMs = 0;
  enemy.lifecycleRemainingMs = definition.deathDurationMs;
  enemy.targetCell = null;
  enemy.statuses.splice(0);
  return true;
}

export function beginEscape(enemy: EnemyInstance, definition: EnemyDefinition): boolean {
  if (enemy.state !== "active") return false;
  enemy.state = "escaped";
  enemy.lifecycleElapsedMs = 0;
  enemy.lifecycleRemainingMs = definition.escapeDurationMs;
  enemy.targetCell = null;
  enemy.statuses.splice(0);
  return true;
}

export function advancePresentation(
  enemy: EnemyInstance,
  definition: EnemyDefinition,
  deltaMs: number,
): EnemyInstance["state"] {
  if (enemy.state === "pending") beginSpawning(enemy, definition);
  if (enemy.state !== "spawning" && enemy.state !== "dying" && enemy.state !== "escaped")
    return enemy.state;
  enemy.lifecycleElapsedMs += deltaMs;
  enemy.lifecycleRemainingMs = Math.max(0, enemy.lifecycleRemainingMs - deltaMs);
  if (enemy.state === "spawning" && enemy.lifecycleRemainingMs === 0) {
    enemy.state = "active";
    enemy.lifecycleElapsedMs = Math.max(definition.spawnDurationMs, definition.spawnProtectionMs);
  } else if (
    (enemy.state === "dying" || enemy.state === "escaped") &&
    enemy.lifecycleRemainingMs === 0
  ) {
    enemy.state = "removed";
  }
  return enemy.state;
}
